export const HTTP_OK = 200;
export const HTTP_INTERNAL_SERVER_ERROR = 500;

export const CORRELATION_SQUARE_METERS_TO_SQUARE_FEET = 10.7639;
